import React from "react";
import Icon, { type IconProps } from "./Icon";

/**
 * CheckCircle2 icon — vendored from Lucide.
 * Source: https://lucide.dev/icons/check-circle-2 (MIT). Copied 2026-05-16.
 *
 * Phase 2c: replaces Banner's `✓` Unicode for tone="success".
 */
export default function CheckCircle2(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </Icon>
  );
}
